<template>
  <div class="row">
    <div class="vx-row">
      <vx-card>
        <vs-row vs-w="12">
          <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
            <vs-button
              icon="keyboard_backspace"
              @click="goBack"
              color="danger"
              type="border"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="10"
            vs-sm="4"
            vs-xs="12"
          >
            <h3 class="pr-5">
              Manage {{ campaignDescription.campaign_name }} Steps Dependency
            </h3>
          </vs-col>
          <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
        </vs-row>
        <vs-row vs-w="12" class="m-4">
          <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="4"
            vs-xs="12"
          >
          </vs-col>
          <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
        </vs-row>
        <table class="table table-striped" style="width:100%;">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Steps</th>
              <th scope="col">Start</th>
              <th scope="col">End</th>
              <th scope="col">Depends On</th>
            </tr>
          </thead>
          <draggable v-model="campaign_steps" tag="tbody">
            <tr v-for="item in campaign_steps" :key="item.steps">
              <td scope="row">{{ item.assigned_step }}</td>
              <td>
                <flat-pickr
                  :config="configdatePicker"
                  placeholder="Choose Start Date"
                  name="start_date"
                  v-validate="'required'"
                  data-vv-as="Date"
                  class="flat-pick"
                  v-model="item.start_date"
                />
              </td>
              <td>
                <flat-pickr
                  :config="configdatePicker"
                  placeholder="Choose End Date"
                  name="end_date"
                  v-validate="'required'"
                  data-vv-as="Date"
                  class="flat-pick"
                  v-model="item.end_date"
                />
              </td>
              <td>
                <v-select
                  :on-change="onChange(item)"
                  label="dependency_name"
                  name="dependent_id"
                  :options="campaign_dependent_steps"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="item.dependent_id"
                />
              </td>
            </tr>
          </draggable>
        </table>

        <vs-popup
          class="holamundo"
          title="Create New Campaign Step"
          :active.sync="createCampaignStepPopupActive"
        >
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Step</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                class="w-full"
                v-validate="'required'"
                data-vv-as="Step"
                name="new_campaign_step"
                v-model="new_campaign_steps.steps"
              />
              <span
                class="text-danger text-sm mt-2"
                v-show="errors.has('new_campaign_step')"
                >{{ errors.first("new_campaign_step") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Description</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full description">
              <vs-textarea
                v-validate="'required'"
                name="new_campaign_step_description"
                data-vv-as="Step Description"
                v-model="new_campaign_steps.description"
              />
              <span
                class="text-danger text-sm mt-2"
                v-show="errors.has('new_campaign_step_description')"
                >{{ errors.first("new_campaign_step_description") }}</span
              >
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                class="mr-3 mb-2"
                @click.prevent="createNewCustomCampaignStep"
                >Submit</vs-button
              >
            </div>
          </div>
        </vs-popup>

        <div class="float-right m-5">
          <!-- <vs-button @click="addNewStep">Add New Step</vs-button> -->

          <vs-button class="ml-5" @click="submitData">Submit</vs-button>
        </div>
        <template> </template>
      </vx-card>
    </div>
  </div>
</template>

<script>
import defineAbilitiesFor from "@/config/abilities";
import moduleStepsManagement from "@/store/campaign-management/client-campaign-steps-management/moduleStepsManagement.js";
import StepsAutocomplete from "@/components/autocomplete/ClientCampaignStepsAutocomplete.vue";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import ElomarkUserAutocomplete from "@/components/autocomplete/ElomarkUserAutocomplete.vue";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import draggable from "vuedraggable";
let id = 1;
export default {
  name: "table-example",
  display: "Table",
  order: 8,
  data: () => ({
    createCampaignStepPopupActive: false,
    campaignId: null,
    configdatePicker: {
      enableTime: false,
      // dateFormat: "Y-m-d H:i",
      format: "d/m/Y",
      altFormat: "d/m/Y",
      altInput: true
    },
    abilities: null,
    new_campaign_steps: {
      steps: null,
      description: null
    },
    campaignDescription: [],
    elomarkUsers: [],
    companySearchComponentKey: 0,
    selected: [],
    log: [],
    campaign_steps: [],
    dependent_steps: [],
    selected_id: null,
    currentx: 1,
    total: 0,
    clientStepsList: ["y", "n"],
    selected_steps: "All",
    size_per_page: [10, 20, 50, 100, 500],
    per_page: 10,
    paginationAttr: {
      page_no: 1,
      per_page: 100
    },
    campaign_dependent_steps: [],
    list: [
      { id: 1, name: "Abby", sport: "basket" },
      { id: 2, name: "Brooke", sport: "foot" },
      { id: 3, name: "Courtenay", sport: "volley" },
      { id: 4, name: "David", sport: "rugby" }
    ],
    dragging: false
  }),
  computed: {
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    }
  },
  components: {
    StepsAutocomplete,
    "v-select": vSelect,
    moduleStepsManagement,
    flatPickr,
    ElomarkUserAutocomplete,
    draggable
  },
  watch: {},
  methods: {
    onChange(val) {
      if (val.dependent_id) {
        // console.log("DEPENDED" , val.dependent_id.id)
        //         console.log("Steps ID" , val.steps)

        // if(val.dependent_id.id != val.steps){

        //     if(val.start_date && val.end_date){

        // let prev_start_date = val.start_date
        //   console.log("Start DATE" , prev_start_date);

        //     let step_end_date = val.end_date
        //   console.log("END DATE" , step_end_date);

        //     const diffIn = moment(step_end_date).diff(
        //   moment(prev_start_date),
        //   "days"
        // );

        //   console.log(diffIn)
        // if (diffIn > 0) {
        //   this.$vs.dialog({
        //     type: "confirm",
        //     color: "danger",
        //     title: `Steps Dependency`,
        //     text: `Please confirm the start is earlier than end date on all the steps.`,
        //     acceptText: "OK"
        //   });
        // }

        // }

        // }

        // console.log(val.dependent_id.id)
        this.fetchCampaignStepByStepId(val);
      }
    },
     fetchCampaignStepByStepId(step) {
      this.$store
        .dispatch(
          "campaignsManagement/fetchCampaignStepByStepId",
          step.dependent_id.id
        )
        .then(res => {
          let result = JSON.parse(res.data);

          result.forEach(element => {
            if (
              element.campaign_client_steps == null &&
              element.custom_steps == null
            ) {
              element.assigned_step = element.master_steps;
            }
            if (element.master_steps == null && element.custom_steps == null) {
              element.assigned_step = element.campaign_client_steps;
            }

            if (
              element.master_steps == null &&
              element.campaign_client_steps == null
            ) {
              element.assigned_step = element.custom_steps;
            }
          });

          let prev_start_date = step.start_date;
          let step_end_date = result.end_date;

          const diffIn = moment(step_end_date).diff(
            moment(prev_start_date),
            "days"
          );
          if (diffIn > 0) {
            this.$vs.dialog({
              type: "confirm",
              color: "danger",
              title: `Steps Dependency`,
              text:
                `Start date of the ` +
                step.assigned_step +
                ` cannot be before the end date of ` +
                result[0].assigned_step,
              acceptText: "OK"
            });
            step.dependent_id = null;
            step.start_date = null;
            step.end_date = null;
            return false;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    submitData() {
      let self = this;
      let dateError = false;
      self.campaign_steps.map(function(ele) {
        if (ele.owner_id == null) {
          self.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: `Steps Dependency`,
            text: `Owner should not be empty. Please choose the owner for the steps.`,
            acceptText: "OK"
          });
          dateError = true;
        }

        if (ele.start_date == null || ele.end_date == null) {
          self.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: `Steps Dependency`,
            text: `Start and End date should not be empty. Please choose start and end date of the steps`,
            acceptText: "OK"
          });
          dateError = true;
        }
        const diffInDays = moment(ele.end_date).diff(
          moment(ele.start_date),
          "days"
        );
        console.log(ele)
        if (diffInDays < 0) {
          self.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: `Steps Dependency`,
            text: `Please confirm the start is earlier than end date on the step ` + ele.assigned_step,
            acceptText: "OK"
          });
          dateError = true;
        }
        // if (ele.dependent_id) {
        //   ele.dependent_id = ele.dependent_id.steps;
        // }

        if (ele.completed_date) {
          ele.end_date = ele.completed_date;
        }
      });

      if (dateError) {
        return false;
      }

      this.campaign_steps.map(function(ele) {
        if (ele.dependent_id) {
          if (ele.dependent_id.steps === undefined) {
            ele.dependent_id = ele.dependent_id.id;
          } else {
            ele.dependent_id = ele.dependent_id.steps;
          }
        }

        // ele.dependent_id = ele.steps
        //  return ele
      });
      this.$vs.loading();

      this.$store
        .dispatch(
          "campaignsManagement/saveArrangedCampaignSteps",
          this.campaign_steps
        )
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Campaign Steps",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Campaign Steps",
              text: "The campaign steps was saved successfully"
            });
            // this.$router.push({
            //   path: `/campaigns/arranged-steps/` + this.campaignId
            // });
            this.$vs.loading.close();

            this.$router.push({
              path: `/campaigns/manage-campaign-steps`
            });
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    createNewCustomCampaignStep() {
      this.new_campaign_steps.campaign_id = this.campaignId;
      this.$store
        .dispatch(
          "campaignsManagement/addCustomCampaignSteps",
          this.new_campaign_steps
        )
        .then(res => {
          let result = JSON.parse(res.data);
          this.campaign_steps.push(result[0]);

          this.campaign_steps.forEach(element => {
            if (
              element.campaign_client_steps == null &&
              element.custom_steps == null
            ) {
              element.assigned_step = element.master_steps;
            }
            if (element.master_steps == null && element.custom_steps == null) {
              element.assigned_step = element.campaign_client_steps;
            }

            if (
              element.master_steps == null &&
              element.campaign_client_steps == null
            ) {
              element.assigned_step = element.custom_steps;
            }
          });
          this.dependent_steps = this.campaign_steps.filter(function(e) {
            e.id = e.steps;
            e.step_name = e.assigned_step;
            return e;
          });
          this.createCampaignStepPopupActive = false;
          this.new_campaign_steps.steps = null;
          this.new_campaign_steps.description = null;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    searchSteps(inputValue) {
      return this.$store
        .dispatch("StepsManagement/searchSteps", inputValue)
        .then(response => {
          if (response) {
            let data = response.data;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name: data[property].steps
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    addNewStep() {
      this.createCampaignStepPopupActive = true;
    },
    handleSearch(searching) {
      console.log(`The Steps searched for: ${searching}`);
    },
    handleSort(key, active) {
      console.log(`the Steps ordered: ${key} ${active}`);
    },
    viewSteps(id) {
      this.$router.replace("/campaigns/client-campaign-steps/" + id);
    },
    editSteps(id) {
      this.$router.replace("/campaigns/client-campaign-steps/edit/" + id);
    },
    // handleChildEvent() {
    //   let self = this;
    //   self.elomarkUsers = moduleElomarkUserManagement.state.elomark_users.datas;
    // },
    confirmDeleteSteps(id) {
      this.selected_id = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Steps`,
        accept: this.deleteSteps,
        acceptText: "Delete"
      });
    },
    fetchElomarkUsers() {
      this.$store
        .dispatch(
          "elomarkUsersManagement/fetchAllElomarkUsers",
          this.paginationAttr
        )
        .then(res => {
          let self = this;
          self.elomarkUsers =
            moduleElomarkUserManagement.state.elomark_users.datas;
          self.elomarkUsers.map(function(ele) {
            ele.full_name = ele.first_name + " " + ele.surname;
          });
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    searchElomarkUser(inputValue) {
      return this.$store
        .dispatch("elomarkUsersManagement/searchElomarkUser", inputValue)
        .then(response => {
          if (response) {
            let data = moduleElomarkUserManagement.state.elomark_user;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name: data[property].first_name + " " + data[property].surname
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchCampaign() {
      this.$store
        .dispatch(
          "campaignsManagement/fetchCampaign",
          this.$route.params.campaignId
        )
        .then(res => {
          this.campaignDescription = res.data;
        })
        .catch(err => {
          console.error(err);
        });
    },
    fetchCamapignSteps() {
      let self = this;
      const campaignId = self.$route.params.campaignId;
      self.campaignId = self.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaignSteps", campaignId)
        .then(res => {
          self.campaign_steps = JSON.parse(res.data);

          self.campaign_steps.forEach(element => {
            if (
              element.campaign_client_steps == null &&
              element.custom_steps == null
            ) {
              element.assigned_step = element.master_steps;
            }
            if (element.master_steps == null && element.custom_steps == null) {
              element.assigned_step = element.campaign_client_steps;
            }

            if (
              element.master_steps == null &&
              element.campaign_client_steps == null
            ) {
              element.assigned_step = element.custom_steps;
            }
          });
          self.campaign_steps.map(function(e) {
            e.owner_id = {
              id: e.owner_id,
              full_name: e.owner_name
            };

            if (e.dependent_id) {
              e.dependent_id = {
                id: e.dependent_id,
                dependency_name: e.dependency_name
              };
            }
            return e;
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    fetchDependents() {
      let self = this;
      const campaignId = self.$route.params.campaignId;
      self.campaignId = self.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaignSteps", campaignId)
        .then(res => {
          self.campaign_dependent_steps = JSON.parse(res.data);

          self.campaign_dependent_steps.forEach(element => {
            if (
              element.campaign_client_steps == null &&
              element.custom_steps == null
            ) {
              element.assigned_step = element.master_steps;
            }
            if (element.master_steps == null && element.custom_steps == null) {
              element.assigned_step = element.campaign_client_steps;
            }

            if (
              element.master_steps == null &&
              element.campaign_client_steps == null
            ) {
              element.assigned_step = element.custom_steps;
            }
          });

          let newArray = [];
          self.campaign_dependent_steps.forEach(function(ele) {
            let newObj = {
              id: ele.steps,
              dependency_name: ele.assigned_step
            };
            newArray.push(newObj);
          });

          self.campaign_dependent_steps = newArray;
        })
        .catch(err => {
          console.error(err);
        });
    },
    deleteSteps() {
      this.$store
        .dispatch("StepsManagement/removeSteps", this.selected_id)
        .then(res => {
          if (res.data.status == "success") {
            this.fetchSteps();
            this.showDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Steps Deleted",
        text: "The User was successfully deleted"
      });
    }
  },
  mounted() {
    this.fetchCamapignSteps();
    this.fetchElomarkUsers();
    this.fetchCampaign();
    this.fetchDependents();
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleStepsManagement.isRegistered) {
      this.$store.registerModule("StepsManagement", moduleStepsManagement);
      moduleStepsManagement.isRegistered = true;
    }
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }
  }
};
</script>
<style>
.flat-pick {
  padding: 0.7rem;
  border-radius: 5px;
  font-size: 1rem;
  color: #626262;
  cursor: pointer;
}
</style>
<style scoped>
tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

th {
  width: 325px !important;
}

td:not(:first-child) {
  padding: 10px;
}
</style>

<style lang="stylus">
.con-expand-Steps
  .con-btns-Steps
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Stepsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
